import { useContext } from 'react';
import { ParentsInfoChartsDataContext } from '../contexts/ParentsInfoChartsDataContext';

export const useParentsInfoChartsDataContext = () => {
    return useContext(ParentsInfoChartsDataContext);
};
